import { BlankSlate } from "@msuite/ui/blank-slate";
import { Droppable, getDroppablePayload } from "@msuite/ui/dnd";
import { queries, type ZeroVehicleAssignmentPlan } from "@msuite/zero";
import { useZeroQuery } from "@msuite/zero/react";
import {
	type UserAssignmentType,
	type UserType,
	useCrewHandler,
} from "@/sites/plan/plan-kanban/use-crew-handler";
import { useCrewContext } from "./context";
import { CrewStaffAssignment } from "./crew-staff-assignment";

export function CrewStaff() {
	/** Hooks */
	const { crewId, planId, isStaffingBlocked } = useCrewContext();
	const crewHandler = useCrewHandler({ crewId, planId });

	/** Zero */
	const [userAssignments] = useZeroQuery(queries.userAssignments.byCrewId({ crewId }));

	/** Render */
	return (
		<Droppable
			className="flex flex-col gap-2 h-max sticky top-11"
			accept={["user", "user-assignment", "user-vehicle-assignment"]}
			handleOnDrop={(element) => {
				const payload = getDroppablePayload(element);
				if (payload.type === "user") {
					crewHandler.onDropUser((payload.item as UserType).id);
				} else if (payload.type === "user-assignment") {
					crewHandler.onDropUser((payload.item as UserAssignmentType).userId);
				} else if (payload.type === "user-vehicle-assignment") {
					const userId = (payload.item as ZeroVehicleAssignmentPlan).userId;
					if (!userId) return;
					crewHandler.onDropUser(userId);
				}
			}}
			isDisabled={userAssignments?.length > 0 || isStaffingBlocked}
		>
			<div className="flex flex-col gap-0 pt-1 h-max pb-1">
				{!userAssignments?.length ? <BlankSlate /> : null}
				{userAssignments?.map((assignment) => (
					<CrewStaffAssignment
						key={assignment.id}
						assignment={assignment}
					/>
				))}
			</div>
		</Droppable>
	);
}
